export enum RouteEnum {
  // -------------------------------------------- authorization
  SIGN_IN = '/login/sign-in',
  SIGN_UP = '/login/sign-up',
  FORGOT_PASSWORD = '/login/forgot-password',
  RESET_PASSWORD = '/login/reset-password',
  CLIENT_SIGN_IN = '/login/client/sign-in',
  // -------------------------------------------- dashboard
  DASHBOARD = '/dashboard',
  SUBSCRIPTION = '/subscription',
  SETTINGS = '/settings',
  USERS = '/users',
  ROLES = '/roles',
  PERMISSIONS = '/permissions',
  TENANT_LIST = '/tenant-list',
  STOCK_OWNERS = '/stock-owners',
  STOCK_OWNER_DETAIL = '/stock-owners/:id',
  CHANNELS = '/channels',
}
